import axios from 'axios';

interface ActivationReportFilter {
  branchId?: number;
  companyId?: number;
}

function caseApiBaseUrl(): string {
  return (process.env.VUE_APP_CASE_API_URL || '').replace(/\/$/, '');
}

function fallbackFileName(filter: ActivationReportFilter): string {
  const scope = filter.branchId != null
    ? `erpc-${filter.branchId}`
    : filter.companyId != null
      ? `company-${filter.companyId}`
      : 'all-erpcs';
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `activation-report-${scope}-${timestamp}.csv`;
}

function fileNameFromHeader(header: string | undefined, fallback: string): string {
  if (!header) {
    return fallback;
  }

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1]);
  }

  const fileNameMatch = header.match(/filename="?([^";]+)"?/i);
  return fileNameMatch ? fileNameMatch[1] : fallback;
}

export async function downloadActivationReport(filter: ActivationReportFilter = {}): Promise<void> {
  const fallback = fallbackFileName(filter);
  const response = await axios.get(`${caseApiBaseUrl()}/Case/DownloadActivationReport`, {
    params: filter,
    responseType: 'blob'
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const fileName = fileNameFromHeader(response.headers['content-disposition'], fallback);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
